import { Heading3, Paragraph } from "../../../../src/common/Markdown";
import * as React from 'react';
export default {
  Heading3,
  Paragraph,
  React
};